<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    column: Object,
    value: Number
})

const componentsStore = useComponentsStore()
const itemDataStore = useItemDataStore()

const item = ref(null)

const component = computed(() => {
    return componentsStore.items.find(o => o.id === props.column.categoryComponentId)
})

const nameField = computed(() => {
    return componentsStore.nameField(props.column.categoryComponentId)
})

const title = computed(() => {
    return item.value ? item.value[nameField.value] : ''
})

// Watcher fetching item data using Pinia store
watch([component, () => props.value], async () => {
    if (!component.value || !props.value) {
        item.value = null
        return
    }

    const obj = await itemDataStore.get({
        tableName: component.value.tableName,
        id: props.value
    })

    item.value = obj
}, {immediate: true})
</script>

<template>
    <span v-html="title"/>
</template>